import React, { useEffect } from 'react'
import Drawer from '../../../components/common/Drawer'
import { useForm } from 'react-hook-form'
import Input from '../../../components/form/input/InputField'
import Label from '../../../components/form/Label'
import toast from 'react-hot-toast'
import { api } from '../../../configs/api'
import { useBusiness } from '../../../context/BusinessContext'

const PipelineEdit = ({ open, handleClose }: { open: boolean; handleClose: () => void }) => {
    const { business, currentTab } = useBusiness()
    const form = useForm({ mode: 'onChange' })
    const formRef = React.useRef<HTMLFormElement>(null)

    const currentPipeline = business.pipelines.find((pipeline: any) => pipeline.value === currentTab)
    form.setValue('name', currentPipeline?.label)

    const updatePipelineContext = () => {
        const newPipelines = business.pipelines.map((pipeline: any) => {
            if (pipeline.value === currentTab) {
                return { ...pipeline, label: form.getValues('name') }
            }
            return pipeline
        })
        business.pipelines = newPipelines
    }

    const handleSave = async (values: any) => {
        if (!currentPipeline || !values.name) {
            toast.error('Preencha o nome do pipeline!')
            return
        }
        try {
            const response = await fetch(`${api}business/updatePipeline`, {
                method: 'POST',
                body: JSON.stringify({
                    pipelineID: currentPipeline.id,
                    name: values.name
                })
            })
            const result = await response.json()

            if (!result) {
                toast.error('Não foi possível alterar o pipeline!')
                return
            }

            updatePipelineContext()

            toast.success('Pipeline alterado com sucesso!')
        } catch (error) {
            console.log(error)
        } finally {
            handleClose()
        }
    }

    if (!open) return null

    return (
        <Drawer
            open={open}
            handleClose={handleClose}
            title='Alterar Pipeline'
            handleSave={() => formRef.current?.requestSubmit()}
        >
            <form ref={formRef} onSubmit={form.handleSubmit(handleSave)}>
                <div className='space-y-3'>
                    <div>
                        <Label required>Nome</Label>
                        <Input {...form.register('name', { required: true })} placeholder='Nome do pipeline' />
                    </div>
                </div>
            </form>
        </Drawer>
    )
}

export default PipelineEdit
